import { connect } from 'react-redux';
import { StoreState } from '../../../../../reducers';

import Grid from '../../../../../components/Editor/CombinePanel/SpreadsSelector/Grid';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			combo: {
				externalPublication: {
					spreads,
				},
			},
		},
	} = state;

	return {
		spreads,
	};
};

export default connect(mapStateToProps)(Grid);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/CombinePanel/SpreadsSelector/Grid/index.tsx